import client from "@/client/publicApiClient.ts";
import { useMutation } from "@tanstack/react-query";
import type { ChangeIdentityEmailMutationRequest, ChangeIdentityEmailMutationResponse } from "../types/ChangeIdentityEmail";
import type { UseMutationOptions } from "@tanstack/react-query";

 type ChangeIdentityEmailClient = typeof client<ChangeIdentityEmailMutationResponse, never, ChangeIdentityEmailMutationRequest>;
type ChangeIdentityEmail = {
    data: ChangeIdentityEmailMutationResponse;
    error: never;
    request: ChangeIdentityEmailMutationRequest;
    pathParams: never;
    queryParams: never;
    headerParams: never;
    response: ChangeIdentityEmailMutationResponse;
    client: {
        parameters: Partial<Parameters<ChangeIdentityEmailClient>[0]>;
        return: Awaited<ReturnType<ChangeIdentityEmailClient>>;
    };
};
/**
 * @summary Change email request
 * @link /api/identity/change-email
 */
export function useChangeIdentityEmail(options: {
    mutation?: UseMutationOptions<ChangeIdentityEmail["response"], ChangeIdentityEmail["error"], ChangeIdentityEmail["request"]>;
    client?: ChangeIdentityEmail["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    return useMutation({
        mutationFn: async (data) => {
            const res = await client<ChangeIdentityEmail["data"], ChangeIdentityEmail["error"], ChangeIdentityEmail["request"]>({
                method: "post",
                url: `/api/identity/change-email`,
                data,
                headers: { "Content-Type": "text/json", ...clientOptions.headers },
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions
    });
}